import React from 'react';
import GREYS_JSON from '../../color/color_greys.json';
export var Initials = function Initials(_ref) {
  var x = _ref.x,
      y = _ref.y,
      fontSize = _ref.fontSize,
      textColor = _ref.textColor,
      children = _ref.children;
  return React.createElement("text", {
    x: x,
    y: y,
    fontSize: fontSize,
    fontWeight: "600",
    textAnchor: "middle",
    fill: GREYS_JSON[textColor]
  }, children);
};